export default import.meta.ROLLDOWN_FILE_URL_NCpIZ12sHv86lRyGv6FpEQ